import { AppBox, AppText } from "../../../../../commons/components";
import { IFootballTeam } from "../../../../../commons/models/football/interface/i-football-team";

interface TournamentReamRemoveProps {
  tournamentSeasonTeam: IFootballTeam;
}
export default function TournamentSeasonTeamRemoveInprogress({ tournamentSeasonTeam }: TournamentReamRemoveProps) {
  return (
    <AppBox flexDirection="column" gap="sm">
      <AppText>
        Removing <strong>“{tournamentSeasonTeam.name}”</strong> In Progress
      </AppText>
      <AppBox className="loader-line"></AppBox>
    </AppBox>
  );
}
